import { useMutation, useQueryClient } from "@tanstack/react-query";
import { usePymbleApi } from "./usePymbleApi";

const API_END_POINT = "/group/admin/bulk";

export interface GroupUpdate {
  StartAt?: string;
  EndAt?: string;
  Icon?: string;
}

/**
 * Hook to perform bulk operations on groups
 */
export function useGroupsBulk() {
  const { callApi } = usePymbleApi();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async ({
      groups,
      update,
    }: {
      groups: string[];
      update: GroupUpdate;
    }) => {
      const request = { groups, update };
      return await callApi("POST", API_END_POINT, { data: request });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["groups"] });
    },
  });

  /**
   * Perform bulk operations on a set of groups.
   */
  const updateGroups = async (groups: string[], update: GroupUpdate) => {
    return mutation.mutateAsync({ groups, update });
  };

  return {
    updateGroups,
    groupsBulkSaving: mutation.isPending,
  };
}
